import AsyncStorage from '@react-native-async-storage/async-storage';
const CHUNK_SIZE = Math.floor(1.9 * 1024 * 1024);
// There's a known limit of 2 MB for retrieving data using AsyncStorage on Android devices.
// https://react-native-async-storage.github.io/async-storage/docs/limits/

function splitIntoChunks(data: string) {
  const chunkSize = CHUNK_SIZE;
  let chunks = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunks.push(data.slice(i, i + chunkSize));
  }
  return chunks;
}

const AsyncStorageChunker = {
  ...AsyncStorage,
  getItem: async <T extends string>(key: T) => {
    const keys = await AsyncStorage.getItem(key);

    if (!keys) {
      return null;
    }

    const parsedKeys = JSON.parse(keys);
    let data = '';

    for (const parsedKey of parsedKeys) {
      const chunk = await AsyncStorage.getItem(parsedKey);
      if (chunk !== null) {
        data += chunk;
      }
    }

    return data;
  },
  isChunkKey: (key: string) => {
    return Boolean(key.match(/_chunk_\d+$/));
  },
  removeItem: async <T extends string>(key: T) => {
    // get all keys that needs to be removed from the storage
    const keys = await AsyncStorage.getItem(key);

    if (!keys) {
      return;
    }

    // remove all data + the keys
    return AsyncStorage.multiRemove([...JSON.parse(keys), key]);
  },
  setItem: async <T extends string>(key: T, value: T) => {
    const chunks: T[] = splitIntoChunks(value) as T[];
    let chunkKeys: { [key: string]: T } = {};

    for (let i = 0; i < chunks.length; i++) {
      const chunkKey: T = `${key}_chunk_${i}` as T;
      chunkKeys[chunkKey] = chunks[i];
    }

    const chunkKeysArray = Object.entries(chunkKeys);
    // store the values + the keys
    return AsyncStorage.multiSet([
      ...chunkKeysArray,
      [key, JSON.stringify(Object.keys(chunkKeys))],
    ]);
  },
};

export default AsyncStorageChunker;
